// Clean, print-ready document layout for a single admission/registration application.
// Rendered off-screen inside a .print-doc container; window.print() reveals only this.
export default function PrintableApplication({ app, college = {}, logo = "" }) {
  if (!app) return null;
  const isReg = app.form_type === "registration";
  const rows = [
    ["Name", app.name],
    ["Father's Name", app.father_name],
    ["Mother's Name", app.mother_name],
    ["Date of Birth", app.dob],
    isReg ? ["Semester", app.semester] : ["Course Applied", app.course],
    ["Department", app.department],
    ["Roll No.", app.roll_no],
    ["ABC ID", app.abc_id],
    ["Aadhar No.", app.aadhar_no],
    ["Registration No.", app.registration_no],
    ["Primary Phone", app.phone],
    ["Secondary Phone", app.phone_secondary],
    ["Present Address", app.present_address],
    ["Permanent Address", app.permanent_address],
  ].filter((r) => r[1]);
  const academic = (app.academic || []).filter((a) => a.institution || a.university_exam);

  const th = { textAlign: "left", padding: "6px 8px", background: "#12345c", color: "#fff", fontSize: 11, border: "1px solid #12345c" };
  const td = { padding: "6px 8px", fontSize: 11, border: "1px solid #d9d4c7", verticalAlign: "top" };
  const tdLabel = { ...td, fontWeight: 700, width: 180, background: "#f7f6f2" };

  return (
    <div style={{ fontFamily: "Georgia, 'Times New Roman', serif", color: "#1a1a1a", padding: "24px 28px", maxWidth: 780, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16, borderBottom: "2px solid #12345c", paddingBottom: 12 }}>
        {logo ? <img src={logo} alt="logo" style={{ width: 64, height: 64, objectFit: "contain" }} /> : null}
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#12345c" }}>{college.name || "Kanggui Christian College"}</div>
          <div style={{ fontSize: 11 }}>{college.affiliation || ""}{college.affNo ? ` (Aff. No. ${college.affNo})` : ""}</div>
          <div style={{ fontSize: 11 }}>{college.location || ""}</div>
        </div>
        {logo ? <div style={{ width: 64 }} /> : null}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#12345c", textTransform: "uppercase", letterSpacing: 1 }}>
          {isReg ? "Registration" : "Admission"} Application Form
        </div>
        {app.photo ? <img src={app.photo} alt="applicant" style={{ width: 96, height: 116, objectFit: "cover", border: "1px solid #d9d4c7" }} /> : null}
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 14 }}>
        <tbody>
          {rows.map(([k, v]) => (
            <tr key={k}><td style={tdLabel}>{k}</td><td style={td}>{v}</td></tr>
          ))}
        </tbody>
      </table>

      {academic.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#6d1f2c", marginBottom: 6 }}>Academic Details</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>Institution</th><th style={th}>Exam/University</th>
                <th style={th}>Marks</th><th style={th}>Division</th><th style={th}>Year</th>
              </tr>
            </thead>
            <tbody>
              {academic.map((a, i) => (
                <tr key={i}>
                  <td style={td}>{a.institution}</td><td style={td}>{a.university_exam}</td>
                  <td style={td}>{a.total_marks}</td><td style={td}>{a.division}</td><td style={td}>{a.year}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: 48 }}>
        <div style={{ textAlign: "center" }}>
          {app.signature ? <img src={app.signature} alt="signature" style={{ height: 44, objectFit: "contain" }} /> : <div style={{ height: 44 }} />}
          <div style={{ borderTop: "1px solid #1a1a1a", fontSize: 10, paddingTop: 4, marginTop: 4, width: 160 }}>Applicant Signature</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ borderTop: "1px solid #1a1a1a", fontSize: 10, paddingTop: 4, marginTop: 48, width: 160 }}>Office / Principal</div>
        </div>
      </div>
    </div>
  );
}
